import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Kept only for links shared while the board briefly lived under `/boards/`.
 * The board's home is the workflow it belongs to, so this forwards there
 * rather than serving a second address for the same surface. The workflow key
 * carries over unchanged; if it names nothing, the board route's own
 * not-found state is the honest answer.
 */
export const Route = createFileRoute(
  '/workspaces/$workspaceId/boards/$workflowKey',
)({
  loader: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/workflows/$workflowKey/board',
      params: {
        workspaceId: params.workspaceId,
        workflowKey: params.workflowKey,
      },
    });
  },
});
